CCL.airportTransfersCategoroy = {
  autoload: [
    ['generateTripInfo', $('.round-trip').length > 0],
    ['wheelChair', $('.wheel-chair-service').length > 0]
  ],

  wheelChair() {
    $('.airport-add-to-cart').attr('data-specialService', JSON.parse($('.wheel-chair-service').attr('data-flag')));
    $('#wheel-chair0').change((event) => {
      $('.airport-add-to-cart').attr('data-specialService', event.target.checked);
    });
    $('#wheel-chair1').change((event) => {
      $('.airport-add-to-cart').attr('data-specialService', event.target.checked);
    });
  },
  generateTripInfo() {
    $('.airport-add-to-cart').attr('disabled', 'disabled');
    $('.selectable-link').each((index, element) => {
      element.dataset.selected = false;
    });
    $('.selectable-link').on('click keypress', (event) => {
      const p = event.target.getAttribute('data-name');
      const group = $('a'.concat('[data-name=').concat(p).concat(']'));
      if ($(event.target).hasClass('selected')) {
        $(event.target).removeClass('selected');
        $('.airport-add-to-cart').attr('disabled', 'disabled');
        $(event.currentTarget).attr('aria-label', $(event.currentTarget).attr('aria-label').replace(/selected/g, ''));
      } else {
        $(group).removeClass('selected');
        $(event.currentTarget).attr('aria-label', `${$(event.currentTarget).attr('aria-label')} selected`);
        $(event.target).addClass('selected');
      }
      const a = $('.round-trip').find('.selectable-link.selected');
      if (a.length) {
        if (a[0].dataset.tripid) {
          $('.airport-add-to-cart').removeAttr('disabled');
        }
        if (!a[0].dataset.tripid) {
          $('.airport-add-to-cart').attr('disabled', 'disabled');
        }
        const variants = (a[1]) ? (a[0].dataset.tripid.concat(','.concat(a[1].dataset.tripid))) : (a[0].dataset.tripid);
        $('.airport-add-to-cart').attr('data-variantids', variants);
      } else {
        $('.airport-add-to-cart').attr('data-variantids', '');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-airport-transfers/pdp-airport-transfers.js